import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";
import Layout from "@/components/Layout";
import SEOHead from "@/components/SEOHead";
import { useLocale } from "@/lib/i18n/useLocale";
import { useCopy } from "@/lib/i18n/copy";
import { entryByKey, HTML_LANG } from "@/lib/i18n/registry";
import { META } from "@/content/pages/home";
import HeroSection from "@/components/home/HeroSection";
import StatementSection from "@/components/home/StatementSection";

/* Below-fold sections — lazy-loaded to reduce initial JS bundle */
const PortfolioSection = lazy(() => import("@/components/home/PortfolioSection"));
const ServicesSection = lazy(() => import("@/components/home/ServicesSection"));
const ProcessSection = lazy(() => import("@/components/home/ProcessSection"));
const TeamSection = lazy(() => import("@/components/home/TeamSection"));
const InvestmentSection = lazy(() => import("@/components/home/InvestmentSection"));
const FinalCTA = lazy(() => import("@/components/home/FinalCTA"));
const EditorialGuide = lazy(() => import("@/components/home/EditorialGuide"));

// Identity (LocalBusiness/legalName/taxID) lives in the canonical #org node in
// Layout.tsx — do not re-add a second Organization/LocalBusiness here (BTQ-33 Phase 1).
const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": "https://eventboutique.pt/#website",
  name: "Event Boutique",
  url: "https://eventboutique.pt",
  publisher: { "@type": "Organization", "@id": "https://eventboutique.pt/#org", name: "Event Boutique" },
};

const Index = () => {
  const locale = useLocale();
  const { t } = useCopy(META);
  // Канонический адрес берётся из реестра, а не пишется литералом: у
  // португальской стороны он свой, и разъехаться они не должны.
  const pair = entryByKey("home");
  const canonical = (locale === "pt" ? pair?.pt : pair?.en) ?? "/";

  return (
  <Layout>
    <SEOHead
      title={t.title}
      description={t.description}
      canonical={canonical}
      lang={HTML_LANG[locale]}
    />
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
    </Helmet>
    <HeroSection />
    <StatementSection />
    <Suspense fallback={null}>
      <PortfolioSection />
      <ServicesSection />
      <ProcessSection />
      <TeamSection />
      <InvestmentSection />
      <FinalCTA />
      <EditorialGuide />
    </Suspense>
  </Layout>
  );
};

export default Index;
